import {
	Component,
	OnInit,
	ViewChild
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { ActivatedRoute } from '@angular/router'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { SpeciesService } from 'src/app/services/species.service'
import { ISpecies } from 'src/app/models/Species'
import {
	getIdentifierName,
	getLoggedUser
} from 'src/app/_helpers/LocalStorage'
import {
	getTreeCategorySpecialWithValue,
	getTreeSpecialCategory,
	removeToolTip
} from 'src/app/_helpers/Utils'
import { NotificationService } from 'src/app/services/notification.service'
import { PlantingService } from 'src/app/services/planting.service'
import { PlantingReportArboreal } from 'src/app/models/Planting'
import { startupPuppeteerLoading } from 'src/app/services/puppeteer-server.service'
import { TreeService } from 'src/app/services/tree.service'

@Component({
	selector: 'app-evaluation-report-arboreal',
	templateUrl: './planting-report-arboreal.component.html'
})
export class PlantingReportArborealComponent implements OnInit {

	constructor(
		private routeActive: ActivatedRoute,
		private plantingService: PlantingService,
		public speciesService: SpeciesService,
		public treeService: TreeService,
		private readonly notificationService: NotificationService
	) {}

	@ViewChild('form') public form: NgForm

	public companyId: string = localStorage.getItem('companyId')
	public identifierName = getIdentifierName()
	public sessionUser: UserAdmin = getLoggedUser()
	public ViewValidation: ViewValidation = new ViewValidation()

	public reports: Array<PlantingReportArboreal> = []
	public species: Array<ISpecies> = []
	public specieInitial: ISpecies
	public speciesScientific: Array<ISpecies> = []
	public oldReportJson: string = ''

	public enableAssignButton: boolean = false
	public enableEditButton: boolean = true
	public multipleReports: boolean = false
	public isLoading: boolean = true
	public permission: boolean = true
	public switchProgress: boolean = false
	public isAdmin: boolean = false
	public openModalAssign: boolean = false
	public isNotModeEdit: boolean = true
	public changedAnotherData: boolean = false
	public disabledButton: boolean = false

	public placeholder: string = 'assets/images/placeholder_report.svg'
	public percentReportReceived: number = 0
	public plantingIds: Array<string> = []
	public fragmentId: string = ''
	public numberOfPages: Array<string> = []
	public showAddressChangeModal: boolean = false

	public openModalChoosePrint: boolean = false

	public ngOnInit(): void {

		this.isAdmin = this.sessionUser.roles.includes('GENERAL_ADMIN') || this.sessionUser.roles.includes('CUSTOMER')
		const ids: string = this.routeActive.snapshot.paramMap.get('plantingIds')
		this.fragmentId = this.routeActive.snapshot.queryParamMap.get('fragmentId')

		this.plantingIds = ids.split(',')

		this.getReports(this.plantingIds)

		if (!this.multipleReports) {
			this.getSpecies()
		}
	}

	public async getReports(ids: Array<string>) {

		const parts = this.arrayPartition(ids)

		let limitProgressUntilAwaitRequest: number = 0


		for (const part of parts) {
			limitProgressUntilAwaitRequest += Math.floor(part.length / ids.length * 100)

			this.progressPercentReceived(limitProgressUntilAwaitRequest)

			try {
				const reports =
					await this.plantingService.getPlantingReportArboreal(part, this.fragmentId).toPromise()
				this.reports = [...this.reports, ...reports]
				this.switchProgress = !this.switchProgress
			} catch (err) {
				console.log('Error', err)
				if (parts.length == 1) {
					this.permission = false
					break
				}
			}
		}

		this.stopProgressPercentReceived()

		if (this.reports.length == 1) {

			const userOwnerWithPermitionUpdate: boolean = Boolean(
				this.reports[0].responsible.idMongo === this.sessionUser._id &&
				this.sessionUser.assignments.includes('PLANTING_REPORT_UPDATE')
			)

			const hasPermitionUpdate = Boolean(
				userOwnerWithPermitionUpdate ||
				this.sessionUser.assignments.includes('PLANTING_REPORT_UPDATE_ALL')
			)

			this.enableAssignButton = Boolean(
				this.reports[0].responsible.idMongo === this.sessionUser._id ||
				this.sessionUser.roles.includes('GENERAL_ADMIN')
			)

			this.enableEditButton = hasPermitionUpdate || this.sessionUser.roles.includes('GENERAL_ADMIN')

			const { qrCodeImage, ...responseWithoutQrcodeImage } = this.reports[0]

			this.oldReportJson = JSON.stringify(responseWithoutQrcodeImage)
		} else {
			this.enableEditButton = false
			this.multipleReports = true
		}

		this.isLoading = false

		startupPuppeteerLoading(document)
	}

	public stopProgressPercentReceived() {
		this.switchProgress = !this.switchProgress
		this.percentReportReceived = 100
	}

	public progressPercentReceived(limit: number) {

		const switchNow: boolean = this.switchProgress

		const intervalId = setInterval(() => {
			if (switchNow != this.switchProgress || this.percentReportReceived >= limit) {
				clearInterval(intervalId)
			}

			this.percentReportReceived < 99 && this.percentReportReceived++
		}, 280)
	}

	public arrayPartition(array: Array<string>) {
		const parts = []

		for (let i = 0; i < array.length; i += 10) {
			const part = array.slice(i, i + 10)
			parts.push(part)
		}

		return parts
	}

	public async getSpecies(): Promise<void> {
		this.species = await this.speciesService.getSpeciesSimple().toPromise()

		this.verifySpecies()

		const arrayManipuleSpeciesScientific = [...this.species]

		this.speciesScientific =
			arrayManipuleSpeciesScientific.sort((a, b) => {
				if (a.nomenclature.scientificName.toLowerCase() < b.nomenclature.scientificName.toLowerCase()) {
					return -1
				}
				return 1
			})

	}

	public verifySpecies() {
		this.reports.forEach(report => {
			const specieActive = this.species.some(specie =>
				specie._id === report.tree.specieId
			)

			if (!specieActive) {
				this.insertSpecieInSpeciesArray(
					report.tree.specieId,
					report.tree.species,
					report.tree.popularName,
					report.tree.family,
					report.tree.source,
					report.tree.specialCategory
				)
			}
		})
	}

	public insertSpecieInSpeciesArray(
		idMongo: string,
		scientificName: string,
		popularName: string,
		botanicalClassification: string,
		origin: string,
		specialCategory: string
	) {
		this.species.push({
			_id: idMongo,
			nomenclature: {
				scientificName,
				popularName,
				botanicalClassification
			},
			characterization: {
				origin
			},
			evaluationComponents: {
				specialCategory
			},
			inactive: true
		})
	}

	public async getPageHeight() {
		let pageHeight = 0

		function findHighestNode(nodesList) {
			for (let i = nodesList.length - 1; i >= 0; i--) {
				if (nodesList[i].scrollHeight && nodesList[i].clientHeight) {
					const elHeight = Math.max(
						nodesList[i].scrollHeight,
						nodesList[i].clientHeight
					)
					pageHeight = Math.max(elHeight, pageHeight)
				}
				if (nodesList[i].childNodes.length) {
					findHighestNode(nodesList[i].childNodes)
				}
			}
		}

		findHighestNode(document.documentElement.childNodes)

		// The entire page height is found
		this.numberOfPages = Array(Math.round(pageHeight / 1361))

		for (let index = 1; index <= this.numberOfPages.length; index++) {
			this.numberOfPages[index - 1] = `${index < 10 ? '0' : ''}${index}`
		}
	}

	public hasChangeSpecie(nameSpecie: string): void {
		this.changedAnotherData = true

		const findSpecie = this.species.find(item => {
			return item.nomenclature.popularName === nameSpecie || item.nomenclature.scientificName === nameSpecie
		})

		this.reports[0].tree.species = findSpecie.nomenclature.scientificName
		this.reports[0].tree.popularName = findSpecie.nomenclature.popularName
		this.reports[0].tree.family = findSpecie.nomenclature.botanicalClassification
		this.reports[0].tree.source = findSpecie.characterization.origin
		this.reports[0].tree.specialCategory =
			getTreeCategorySpecialWithValue(findSpecie.evaluationComponents.specialCategory)
	}

	public onChangeInputMensurament(event: { fieldName: string, value: number }) {

		if (event.fieldName == 'totalHeight') {
			this.reports[0].tree.totalHeight = String(event.value)
		}
		if (event.fieldName == 'dapCap') {
			this.reports[0].tree.dapCap = String(event.value)
		}
		if (event.fieldName == 'stemHeight') {
			this.reports[0].tree.stemHeight = String(event.value)
		}
		if (event.fieldName == 'woodVolume') {
			this.reports[0].tree.woodVolume = String(event.value)
		}
		if (event.fieldName == 'cupProjection') {
			this.reports[0].tree.cupProjection = String(event.value)
		}

		this.hasChangeInput()
	}

	public async saveEditEvaluation(): Promise<void> {
		this.disabledButton = true

		const dataEdit = this.reports[0]
		const oldDataCopy = JSON.parse(this.oldReportJson)
		const oldAddress = oldDataCopy.address.street
	 const newAddress = dataEdit.address.street
		if (oldAddress !== newAddress) {
			this.showAddressChangeModal = true
		}

		dataEdit.tree.specialCategory = getTreeSpecialCategory(dataEdit.tree.specialCategory)

		dataEdit.oldReport = this.oldReportJson

		dataEdit.qrCodeImage = ''

		try {
			const response: string =
				await this.plantingService.updatePlantingReportArboreal(dataEdit, this.plantingIds[0]).toPromise()

			this.disabledButton = false

			this.notificationService.notify(response, 200)

			if (!this.showAddressChangeModal) {
				window.location.reload()
			}
		} catch (error) {
			this.reports[0].tree.specialValue = dataEdit.tree.specialValue

			this.disabledButton = false

			this.notificationService.notify(error.error.message, error.error.statusCode || 400)
		}
		finally {
			this.disabledButton = false
		}
		if (!this.showAddressChangeModal) {
			this.reloadWindow()
		}
	}

	public enableFieldToEdit(): void {
		this.isNotModeEdit = false
	}

	public hasChangeInput(): void {
		this.changedAnotherData = true
	}

	public openSelectionModeModal() {
		removeToolTip()
		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public async exportReport() {
		const type = 'planting-report-arboreal'
		const ids = this.reports.map(report => report.idMongo)

		this.treeService.exportReport({type, ids, fragmentId: Number(this.fragmentId)})

		this.openSelectionModeModal()
	}

	public async printOut() {
		this.openSelectionModeModal()

		if (this.numberOfPages.length == 0) {
			this.getPageHeight()
		}

		setTimeout(() => {
			window.print()
		}, 200)
	}

	public openCloseModalAssign() {
		this.openModalAssign = !this.openModalAssign
	}

	public reloadWindow() {
				setTimeout(() => {
						window.location.reload()
				}, 500)
		}

	public closeAddressCloseModal() {
		this.showAddressChangeModal = false
		window.location.reload()
	}
}
